import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IdentityService } from './core/identity.service';
import { MenuService } from './core/menu.service';

@UntilDestroy()
@Component({
    selector: 'nova-catch-all',
    standalone: true,
    imports: [RouterModule],
    template: `@if (!isValidRoute) {
        <div class="not-found"
            ><h1>Oops, this page doesn't exist!</h1><a [routerLink]="['/welcome/home']">Take me home</a></div
        >
    }`,
    styles: [
        `
            .not-found {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatchAllComponent implements OnInit {
    isValidRoute = true;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly location: Location,
        private readonly identityService: IdentityService,
        private readonly menuService: MenuService
    ) {}

    ngOnInit() {
        this.route.url.pipe(untilDestroyed(this)).subscribe((url) => {
            const href = '/' + url.map((val) => val.path).join('/');

            // if (this.isValidRoute) { //assume it's an AngularJS route and proceed anyway
            if (MenuService.publicRoutes.includes(href) || this.identityService.exists()) {
                this.location.go(href);
            } else {
                this.router.navigate(['/signin']);
            }
            // }
        });
    }
}
